
(function () {

    function getHiddenVariants() {
        return window.hiddenVariants || [];
    }


    /*
     * Get the currently selected value for an option.
     *
     * Swatch King structure:
     *
     * <li class="swatch-view-item"
     *     orig-value="16mm"
     *     aria-checked="true">
     *
     *     <div class="swatch-button"
     *          swatch-option="option1">
     */
    function getSelectedOption(optionName) {

        const items = document.querySelectorAll(
            '.swatch-view-item'
        );

        for (const item of items) {

            const button = item.querySelector(
                '[swatch-option="' + optionName + '"]'
            );

            if (!button) {
                continue;
            }

            if (item.getAttribute('aria-checked') === 'true') {

                return (
                    item.getAttribute('orig-value') ||
                    button.getAttribute('orig-value') ||
                    button.getAttribute('data-value') ||
                    ''
                ).trim();
            }
        }

        return null;
    }


    /*
     * Check whether this particular swatch should be hidden.
     */
    function shouldHideSwatch(item) {

        const button = item.querySelector('[swatch-option]');

        if (!button) {
            return false;
        }

        const optionName = button.getAttribute('swatch-option');

        const value = (
            item.getAttribute('orig-value') ||
            button.getAttribute('orig-value') ||
            button.getAttribute('data-value') ||
            ''
        ).trim();


        /*
         * IMPORTANT:
         *
         * Never hide option1.
         *
         * In this product:
         * option1 = Thickness
         * option2 = Color
         */
        if (optionName === 'option1') {
            return false;
        }


        const hiddenVariants = getHiddenVariants();

        if (!hiddenVariants.length || !value) {
            return false;
        }


        /*
         * Current selected Thickness.
         */
        const selectedOption1 = getSelectedOption('option1');


        /*
         * Current selected Color.
         */
        const selectedOption2 = getSelectedOption('option2');


        /*
         * option2 = Color
         */
        if (optionName === 'option2') {

            return hiddenVariants.some(function (hiddenVariant) {

                /*
                 * The hidden variant must belong to
                 * the currently selected thickness.
                 */
                if (
                    selectedOption1 &&
                    hiddenVariant.option1 !== selectedOption1
                ) {
                    return false;
                }


                /*
                 * The color must match the hidden variant.
                 */
                return hiddenVariant.option2 === value;

            });
        }


        /*
         * option3
         */
        if (optionName === 'option3') {

            return hiddenVariants.some(function (hiddenVariant) {

                if (
                    selectedOption1 &&
                    hiddenVariant.option1 !== selectedOption1
                ) {
                    return false;
                }

                if (
                    selectedOption2 &&
                    hiddenVariant.option2 !== selectedOption2
                ) {
                    return false;
                }

                return hiddenVariant.option3 === value;

            });
        }


        return false;
    }


    function hideSwatches() {

        document.querySelectorAll(
            '.swatch-view-item[orig-value]'
        ).forEach(function (item) {

            if (shouldHideSwatch(item)) {
                item.style.display = 'none';
            } else {
                item.style.display = '';
            }

        });
    }


    /*
     * Swatch King loads dynamically.
     */
    const observer = new MutationObserver(function () {
        hideSwatches();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });


    /*
     * Initial check.
     */
    hideSwatches();


    /*
     * Re-check after selecting a swatch.
     */
    document.addEventListener('click', function (event) {

        const swatch = event.target.closest(
            '.swatch-view-item'
        );

        if (!swatch) {
            return;
        }

        setTimeout(function () {
            hideSwatches();
        }, 50);

    });

})();
/*
* --- Product Grid
*/
function removeHiddenSwatches() {

    document.querySelectorAll('.grid-product[data-hidden-variants]').forEach(function(card) {

        let hiddenVariants = [];

        try {
            hiddenVariants = JSON.parse(
                card.getAttribute('data-hidden-variants') || '[]'
            );
        } catch (error) {
            console.error('Unable to parse hidden variants:', error);
            return;
        }

        if (!hiddenVariants.length) {
            return;
        }


        /*
         * Get the selected option value INSIDE THIS PRODUCT CARD.
         */
        function getSelectedOption(optionName) {

            const items = card.querySelectorAll(
                '.swatch-view-item'
            );

            for (const item of items) {

                const button = item.querySelector(
                    '[swatch-option="' + optionName + '"]'
                );

                if (!button) {
                    continue;
                }

                if (item.getAttribute('aria-checked') === 'true') {

                    return (
                        item.getAttribute('orig-value') ||
                        button.getAttribute('orig-value') ||
                        button.getAttribute('data-value') ||
                        ''
                    ).trim();
                }
            }

            return null;
        }


        /*
         * Determine whether an individual swatch
         * should be hidden.
         */
        function shouldHideSwatch(item) {

            const button = item.querySelector('[swatch-option]');

            if (!button) {
                return false;
            }

            const optionName = button.getAttribute('swatch-option');

            const value = (
                item.getAttribute('orig-value') ||
                button.getAttribute('orig-value') ||
                button.getAttribute('data-value') ||
                ''
            ).trim();

            if (!value) {
                return false;
            }


            /*
             * Determine whether this product has
             * more than one option.
             */
            const hasMultipleOptions = hiddenVariants.some(function(hiddenVariant) {
                return hiddenVariant.option2 || hiddenVariant.option3;
            });


            /*
             * SINGLE OPTION PRODUCT
             *
             * option1 itself is the variant value.
             *
             * Example:
             *
             * Black
             * Red
             * Blue
             */
            if (optionName === 'option1' && !hasMultipleOptions) {

                return hiddenVariants.some(function(hiddenVariant) {

                    return hiddenVariant.option1 === value;

                });
            }


            /*
             * MULTI OPTION PRODUCT
             *
             * option1 is the parent/group.
             *
             * Example:
             *
             * option1 = Thickness
             * option2 = Colour
             *
             * NEVER hide option1.
             */
            if (optionName === 'option1') {
                return false;
            }


            /*
             * OPTION 2
             *
             * Example:
             *
             * 16mm
             *   ├── Black
             *   ├── Red
             *   └── Australian Green and Gold ← hide
             */
            if (optionName === 'option2') {

                const selectedOption1 = getSelectedOption('option1');

                return hiddenVariants.some(function(hiddenVariant) {

                    /*
                     * If option1 is selected, it must match
                     * the hidden variant's option1.
                     */
                    if (
                        selectedOption1 &&
                        hiddenVariant.option1 !== selectedOption1
                    ) {
                        return false;
                    }

                    return hiddenVariant.option2 === value;

                });
            }


            /*
             * OPTION 3
             */
            if (optionName === 'option3') {

                const selectedOption1 = getSelectedOption('option1');
                const selectedOption2 = getSelectedOption('option2');

                return hiddenVariants.some(function(hiddenVariant) {

                    if (
                        selectedOption1 &&
                        hiddenVariant.option1 !== selectedOption1
                    ) {
                        return false;
                    }

                    if (
                        selectedOption2 &&
                        hiddenVariant.option2 !== selectedOption2
                    ) {
                        return false;
                    }

                    return hiddenVariant.option3 === value;

                });
            }


            return false;
        }


        /*
         * Process the swatches in this product card.
         */
        const swatches = card.querySelectorAll(
            'variant-swatch-king .swatch-view-item[orig-value]'
        );


        if (!swatches.length) {
            return;
        }


        swatches.forEach(function(item) {

            if (shouldHideSwatch(item)) {
                item.style.display = 'none';
            } else {
                item.style.display = '';
            }

        });

    });
}


/*
 * Initial attempt
 */
removeHiddenSwatches();


/*
 * Swatch King loads dynamically.
 */
let hiddenSwatchAttempts = 0;

const hiddenSwatchInterval = setInterval(function() {

    removeHiddenSwatches();

    hiddenSwatchAttempts++;

    if (hiddenSwatchAttempts >= 20) {
        clearInterval(hiddenSwatchInterval);
    }

}, 500);


/*
 * Handle AJAX/filter/infinite-load changes.
 */
const hiddenSwatchObserver = new MutationObserver(function(mutations) {

    let swatchAdded = false;

    mutations.forEach(function(mutation) {

        mutation.addedNodes.forEach(function(node) {

            if (node.nodeType !== 1) {
                return;
            }

            if (
                node.matches?.('variant-swatch-king') ||
                node.querySelector?.('variant-swatch-king')
            ) {
                swatchAdded = true;
            }

        });

    });


    if (swatchAdded) {
        removeHiddenSwatches();
    }

});


hiddenSwatchObserver.observe(document.body, {
    childList: true,
    subtree: true
});


/*
 * Re-check when a Swatch King option is selected.
 */
document.addEventListener('click', function(event) {

    const swatch = event.target.closest(
        '.grid-product .swatch-view-item'
    );

    if (!swatch) {
        return;
    }

    setTimeout(function() {
        removeHiddenSwatches();
    }, 50);

});

/*
* cross sell
*/


const rebuyHiddenVariantIds = [
    '48916732903728-1 '
];

function hideRebuyVariants() {

    document.querySelectorAll('.rebuy-product-block').forEach(function(product) {

        // Dropdown options
        product.querySelectorAll('.rebuy-select option').forEach(function(option) {

            if (rebuyHiddenVariantIds.includes(option.value)) {
                option.remove();
            }

        });

        // Radio / button swatches
        product.querySelectorAll('.rebuy-product-options__button-swatch').forEach(function(swatch) {

            const input = swatch.querySelector('input');

            if (input && rebuyHiddenVariantIds.includes(input.value)) {
                swatch.remove();
            }

        });

    });
}

hideRebuyVariants();

const rebuyVariantObserver = new MutationObserver(function() {
    hideRebuyVariants();
});

rebuyVariantObserver.observe(document.body, {
    childList: true,
    subtree: true
});
